import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import HyperLinkCell from './Hyperlink';

export const columns = [
    {
        dataField: 'Warehouse',
        caption: 'Warehouse',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowEditing: false,
        allowSorting: true,
    },
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        fixed: true,
        allowSorting: false,
    },
    {
        dataField: 'Movement',
        caption: 'Movement',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md1,
        allowSorting: false,
        fixed: true,
        cellComponent: HyperLinkCell,
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'Balance',
        caption: 'Balance',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right'
    },
    {
        dataField: 'CostEach',
        caption: 'Cost each',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        allowEditing: false,
        alignment: 'right'
    },
    {
        dataField: 'Price',
        caption: 'Price',
        minWidth: COLUMN_SIZE.md0,
        width: COLUMN_SIZE.md0,
        allowSorting: false,
        allowEditing: false,
        format: '#0.00',
        alignment: 'right'
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
        allowEditing: false,
    }
];
